<template>
    <svg  version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" :width="width" :height="height" xml:space="preserve">
        <rect class="st0" width="24" height="24"/>
        <g>
	<path :class="secondaryColor" d="M16.29,4.08L16.29,4.08c-0.44-0.23-0.98-0.07-1.21,0.36C14.84,4.87,15,5.42,15.44,5.65
		c2.33,1.26,3.77,3.7,3.77,6.34c0,3.98-3.24,7.21-7.21,7.21c-3.98,0-7.21-3.24-7.21-7.21c0-2.65,1.45-5.08,3.77-6.34
		c0.21-0.11,0.36-0.3,0.43-0.53c0.07-0.23,0.04-0.47-0.07-0.68C8.69,4.01,8.14,3.84,7.71,4.08C4.8,5.66,3,8.69,3,12
		c0,4.96,4.04,9,9,9s9-4.04,9-9C21,8.69,19.2,5.66,16.29,4.08z"/>
            <path :class="secondaryColor" d="M11.99,3C11.5,3,11.1,3.4,11.1,3.89v7.21c0,0.49,0.4,0.89,0.89,0.89s0.89-0.4,0.89-0.89V3.89
		C12.89,3.4,12.49,3,11.99,3z"/>
</g>
</svg>
</template>

<script>
export default {
    name: "logoutIcon",
    props: [ 'width', 'height'],
    computed: {
        secondaryColor() {
            return 'svg-secondary-color';
        }
    }
}
</script>

<style scoped>
.st0{opacity:0;fill:#FFFFFF;}
</style>



// WEBPACK FOOTER //
// src/common/components/svg/shared/logoutIcon.vue